import { TranslationObject } from '../i18n/translation';

const namespace = 'addpracticeplace';
const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Registrere nytt praksissted',
    en: 'Register new practice place',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Her kan du registrere et nytt praksissted',
    en: 'Here you can register a new practice place',
  },
  organisasjontitle: {
    id: `${namespace}.organisasjontitle`,
    nb: 'Organisasjon',
    en: 'Organization',
  },
  organisasjonsubtitle: {
    id: `${namespace}.organisasjonsubtitle`,
    nb: 'Undersøk om det allerede er registrert en organisasjon for praksisstedet',
    en: "Check if there's already an organization registered for the practice place",
  },
  praksisstedtitle: {
    id: `${namespace}.praksisstedtitle`,
    nb: 'Praksissted',
    en: 'Practice place',
  },
  praksisstedsubtitle: {
    id: `${namespace}.praksisstedsubtitle`,
    nb: 'Registrer nytt praksissted',
    en: 'Register new practice place',
  },
  besoksAdresse: {
    id: `${namespace}.besoksAdresse`,
    nb: 'Besøksadresse',
    en: 'Visiting address',
  },
  kontaktInfo: {
    id: `${namespace}.kontaktInfo`,
    nb: 'Kontaktinformasjon',
    en: 'Contact information',
  },
  ukjentOrgnr: {
    id: `${namespace}.ukjentOrgnr`,
    nb: 'Det eksisterer ingen praksissteder med orgnr. {orgnr} i Arbeidslivsportalen. Det nye praksisstedet vil bli lagret som en ny organisasjon.',
    en: 'No practice place with orgnr. {orgnr} exists in Arbeidslivsportalen. The new practice place will be saved as a new organization.',
  },
  kjentOrgnr: {
    id: `${namespace}.kjentOrgnr`,
    nb: 'Organisasjonsnummer {orgnr} eksisterer i FS, vennligst velg en eier i hierarkiet.',
    en: 'Organisation number {orgnr} exists in FS. Please select the owner in the hierarchy.',
  },
  cancel: {
    id: `${namespace}.cancel`,
    nb: 'Avbryt',
    en: 'Cancel',
  },
  save: {
    id: `${namespace}.save`,
    nb: 'Lagre',
    en: 'Save',
  },
  isSaving: {
    id: `${namespace}.isSaving`,
    nb: 'Lagrer...',
    en: 'Saving...',
  },
  saveSuccess: {
    id: `${namespace}.saveSuccess`,
    nb: 'Praksissted lagret',
    en: 'Save successful',
  },
  orgnr: {
    id: `${namespace}.orgnr`,
    nb: 'Organisasjonsnummer',
    en: 'Organization number',
  },
  invalidOrgnr: {
    id: `${namespace}.invalidOrgnr`,
    nb: 'Ugyldig organisasjonsnummer!',
    en: 'Invalid organization number!',
  },
  eier: {
    id: `${namespace}.eier`,
    nb: 'Velg eier som praksisstedet skal ligge under',
    en: 'Choose which organization to place this place under',
  },
  aktivDato: {
    id: `${namespace}.aktivDato`,
    nb: 'Aktiv fra',
    en: 'Active from',
  },
  navnbokmaal: {
    id: `${namespace}.navnbokmaal`,
    nb: 'Navn, bokmål',
    en: 'Name, bokmål',
  },
  navnnynorsk: {
    id: `${namespace}.navnnynorsk`,
    nb: 'Navn, nynorsk',
    en: 'Name, nynorsk',
  },
  navnengelsk: {
    id: `${namespace}.navnengelsk`,
    nb: 'Navn, engelsk',
    en: 'Name, english',
  },
  adresselinje1: {
    id: `${namespace}.adresselinje1`,
    nb: 'Adresselinje 1',
    en: 'Address line 1',
  },
  adresselinje2: {
    id: `${namespace}.adresselinje2`,
    nb: 'Adresselinje 2',
    en: 'Address line 2',
  },
  postnr: {
    id: `${namespace}.postnr`,
    nb: 'Postnr',
    en: 'Postcode',
  },
  poststed: {
    id: `${namespace}.poststed`,
    nb: 'Poststed',
    en: 'Town',
  },
  adresseLand: {
    id: `${namespace}.adresseLand`,
    nb: 'Velg land',
    en: 'Choose country',
  },
  kommune: {
    id: `${namespace}.kommune`,
    nb: 'Velg kommune',
    en: 'Choose county',
  },
  telefonLand: {
    id: `${namespace}.telefonLand`,
    nb: 'Land nr',
    en: 'Country code',
  },
  telefon: {
    id: `${namespace}.telefon`,
    nb: 'Telefon nr',
    en: 'Telephone nr',
  },
  epost: {
    id: `${namespace}.epost`,
    nb: 'Epost',
    en: 'Email',
  },
  url: {
    id: `${namespace}.url`,
    nb: 'URL',
    en: 'URL',
  },
  autofillPossible: {
    id: `${namespace}.autofillPossible`,
    nb: 'Enkelte verdier kan fylles inn automatisk.',
    en: 'Some values may be retrieved automatically.',
  },
  autofillBtn: {
    id: `${namespace}.autofillBtn`,
    nb: 'Fyll inn verdier automatisk',
    en: 'Fill inn automatically',
  },
  praksisstedtypekoder: {
    id: `${namespace}.praksisstedtypekoder`,
    nb: 'Velg typekode for praksissted',
    en: 'Pick typekode for practice place',
  },
  notInEnhetsreg: {
    id: `${namespace}.notInEnhetsreg`,
    nb: 'Finner ikke organisasjonsnummeret i Enhetsregisteret.',
    en: 'Cannot find the organization number in Enhetsregisteret.',
  },
  matchPraksisstedText: {
    id: `${namespace}.matchPraksisstedText`,
    nb: 'Praksissteder med lignende navn',
    en: 'Practice places with similar names',
  },
  matchPraksisstedSubtext: {
    id: `${namespace}.matchPraksisstedSubtext`,
    nb: 'Sjekk at du har skrevet korrekt navn på praksissted for å finne praksisstedet i listen',
    en: 'Be sure that you have the correct practice place name to be able to find it in the list',
  },
  praksisstedMatchFound: {
    id: `${namespace}.praksisstedMatchFound`,
    nb: 'Det eksisterer praksissted som inneholder ditt søk',
    en: 'There is registered a practice place that contains your search',
  },
  modalNavn: {
    id: `${namespace}.modalNavn`,
    nb: 'Navn:',
    en: 'Name:',
  },
  modalAdresse: {
    id: `${namespace}.modalAdresse`,
    nb: 'Adresse:',
    en: 'Address:',
  },
  modalPostnr: {
    id: `${namespace}.modalPostnr`,
    nb: 'Postnr:',
    en: 'Postcode:',
  },
  praksisstedDuplikater: {
    id: `${namespace}.praksisstedDuplikater`,
    nb: 'Sjekk mulige duplikater',
    en: 'Check possible duplicates',
  },
};
export default translations;
